import numbro from 'numbro';

function detectFormat(currency = 'USD'): string {
  let result = '0,0.00';

  switch (currency) {
    case 'BCC':
    case 'BTC':
    case 'BTG':
      result = '0,0.00000000';
      break;
    case 'USDT':
      result = '0,0.00'; // в теории там 6 знаков после запятой
      break;
  }

  return result;
}

export function MoneyFormat(amount: number, currency = 'USD'): string {
  const format = detectFormat(currency);

  return numbro(amount).format(format);
}
